import { useContext } from 'react';
import { ToastContext } from '../services/contexts/toast';

const useToast = () => {
  const context = useContext(ToastContext);
  return context;
};

export default useToast;
